/* tokens.js — JS mirror of theme.css
 *
 * Leaflet, Canvas, and chart libraries set colors imperatively as SVG/Canvas
 * attributes, where `var(--x)` does NOT resolve. Import literals from here for
 * those call sites. Keep in sync with theme.css.
 */

export const color = {
  ink950: '#0B1220',
  surface900: '#111A2B',
  surface800: '#18243A',

  brandNavy: '#14304D',
  signalCyan: '#3FC1CB',
  signalCyanInk: '#0E7C86',

  textPrimary: '#E6EDF5',
  textMuted: '#9FB0C3',

  statusSuccess: '#4CC38A',
  statusWarn: '#E5A13C',
  statusError: '#E5534B',

  dataBle: '#4CA3DD',
  dataWifi: '#8A7CE0',
  dataUnknown: '#7C8A9C',
};

/** Device-type marker color. Deliberately not brand cyan — cyan means "selected". */
export const typeColor = (type) =>
  ({ ble: color.dataBle, wifi: color.dataWifi }[type] ?? color.dataUnknown);

/** Signal strength → semantic status color. */
export const rssiColor = (rssi) =>
  rssi > -60 ? color.statusSuccess : rssi > -80 ? color.statusWarn : color.statusError;
